import {
    GET_CREDIT_LISTING_FAIL,
    GET_CREDIT_LISTING_SUCCESS,
    RESET_CREDIT_ACTION_STATE,
    RESET_CREDIT_STATE,
} from "./actionTypes"

const INIT_STATE = {
    creditListing: [],
    error: [],
}

const Credit = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CREDIT_LISTING_SUCCESS:
            return {
                ...state,
                creditListing: action.payload
            }
        case GET_CREDIT_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_CREDIT_ACTION_STATE:
            return {
                ...state,
                creditListing: [],
                error: [],
            }
        case RESET_CREDIT_STATE:
            return {
                ...state,
                creditListing: [],
                error: [],
            }
        default:
            return state
    }
}

export default Credit
